const translations = {
    headline: {
        type: 'text',
        defaultValue: 'Powiązane Artykuły',
    },
};

export default translations;
